import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/cart/')({
	beforeLoad: ({
		context: {
			auth: { canAccessMultipleStores },
		},
	}) => {
		if (!canAccessMultipleStores) {
			throw redirect({
				to: '/cart/products',
				replace: true,
			});
		}

		throw redirect({
			to: '/cart/stores',
			replace: true,
		});
	},
});
